import { OpenCageProvider } from "@anyways-open/geocoding-common";
import { get, writable } from "svelte/store";
import { appManager } from "../AppManager";
export class NewProjectModalManager {
    constructor(localeStore) {
        this.mapViewStore = writable(undefined);
        this.localeStore = localeStore;
        this.createGeocodingProvider();
        this.localeStore.subscribe(_ => this.createGeocodingProvider());
    }
    getMapViewStore() {
        return this.mapViewStore;
    }
    createGeocodingProvider() {
        const openCageSettings = {
            locale: get(this.localeStore),
        };
        this.geocodingProvider = new OpenCageProvider(appManager.apiKeys.opencage, openCageSettings);
    }
    onZoomTo(location) {
        this.mapViewStore.set(location);
    }
    async geocodeForward(query) {
        return await this.geocodingProvider.forward(query);
    }
}
